// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3whSm","addWidgetButton":"Header_addWidgetButton__3P6VS","dashboardTabs":"Header_dashboardTabs__2fBjU","active":"Header_active__lr3yQ"};